import { Injectable, inject } from '@angular/core';
import {
    UserPositionDto,
    UserPositionExitCleanupTask,
} from '@pf/platform-core/domain';
import { PutAwayListDataService } from '@pf/platform-wms/domain';
import { Observable, of } from 'rxjs';
import { PutawayContext } from '../../models/putaway-context.model';
import { CpwUserPositionTypes } from '../../UserPositionTypes';

type PutawayContextWithWarehouse = PutawayContext & {
    warehouseId?: string;
};

@Injectable({ providedIn: 'root' })
export class PutAwayPositionExitCleanupTask
    implements UserPositionExitCleanupTask
{
    readonly id = 'putaway-unclaim';

    private readonly putAwayListDataService = inject(PutAwayListDataService);

    appliesTo(position: UserPositionDto): boolean {
        if (position.userPositionTypeName !== CpwUserPositionTypes.Putaway) {
            return false;
        }
        const ctx = position.context as PutawayContextWithWarehouse | undefined;
        return !!ctx?.putAwayListId && !!ctx?.warehouseId;
    }

    cleanup$(position: UserPositionDto): Observable<unknown> {
        const ctx = position.context as PutawayContextWithWarehouse | undefined;
        const warehouseId = ctx?.warehouseId;
        const putAwayListId = ctx?.putAwayListId;
        if (!warehouseId || !putAwayListId) return of(null);
        return this.putAwayListDataService.unClaimPutAwayLists$(warehouseId, [
            putAwayListId,
        ]);
    }
}
